export default __webpack_public_path__ + "static/media/Image 35.5bb43b44.png";